<template>
  <div class="page">
    <div class="page-header">
      <div class="page-header-start">
        <ul class="tabs">
          <li v-if="filterBy === 'showSub'" class="active" @click="filterBy = ''">
            <i class="fa-regular fa-square-check"></i>
            <p>Hide sub job function</p>
          </li>
          <li v-else @click="filterBy = 'showSub'">
            <i class="fa-regular fa-square-check"></i>
            <p>Show sub job function</p>
          </li>
        </ul>
      </div>
      <div class="page-start-end">
        <input type="text" class="input" placeholder="Search" v-model="search" />
      </div>
    </div>
    <div class="page-content">
      <ul>
        <li v-for="(i, index) in jobFunctionSelect" :key="index">
          <p>{{ i.name }}</p>
          <div v-if="filterBy === 'showSub'">
            <ul>
              <li v-for="(o, indx) in i.items" :key="indx">
                <span>{{ o.name }}</span>
                <i class="fa-solid fa-pen" @click="setIndex(index, o.name, o._id)" v-if="permission === 'developer'"></i>
              </li>
            </ul>
            <br />
            <small v-if="error && index === isIndex" style="color: red">{{
              error
            }}</small>
            <small v-if="msg && index === isIndex" style="color: rgb(12, 170, 46)">{{ msg }}</small>
            <!-- <div class="input-group">
              <div v-for="(p, pIdx) in inputs">
                <input v-if="pIdx === index" style="width: 100%" type="text" class="input" placeholder="Sub job function"
                  v-model="inputs[pIdx]" />
              </div>
              <button class="button primary" v-if="status && index === isIndex" @click="update(index)">
                Update
              </button>
              <button class="button primary" v-else @click="add(index)">
                Save
              </button>
            </div> -->
          </div>
          <!-- <div class="input-group">
            <input type="text" class="input" />
            <button class="button primary">Save</button>
          </div> -->
        </li>
      </ul>

      <div class="widget" v-if="permission === 'developer'">
        <div class="input-group">
          <input type="text" class="input" v-model="name" placeholder="Sub job function" />
          <button class="button primary">Save</button>
        </div>
        <div class="widget-header">
          <h3>Ref. keyword of :</h3>
          <p>Administration / Operation / Clerical Support</p>
        </div>
        <div class="keywords">
          <textarea class="textarea" v-model="text" @keyup="sendMsgGPT()"></textarea>
        </div>
        <div class="buttons">
          <button class="button grey">Cancel</button>
          <button class="button primary">Save</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apolloClient } from "@/services/apollo-client";
import {
  GET_NEW_JOB_FUNCTION,
  ADD_NEW_JOB_FUNCTION,
} from "@/graphql/manage/add";
import Axios from "axios";
import { REUSE } from "@/graphql/manage/query";
export default {
  data: () => ({
    filterBy: "showSub",
    search: "",
    info: [],
    isParent: "",
    _id: "",
    name: "",
    status: false,
    isIndex: null,
    childIndx: null,
    inputs: [],
    msg: "",
    error: "",
    text: "",
    funcs: [],
    permission: "",
  }),
  computed: {
    jobFunctionSelect() {
      return this.info.filter((i, index) => {
        let name = i.name.toLowerCase().match(this.search.toLowerCase());
        if (!name) {
          name = i.items.some((f) => f.name.toLowerCase().match(this.search.toLowerCase()));
        }
        return name
      })
    }
  },
  methods: {
    async queryJobFunction() {
      const res = await apolloClient.query({
        query: REUSE,
        variables: {
          type: "JobFunction",
        },
      });
      this.funcs = res.data.getReuses;
    },
    async fetchJobFunction() {
      const res = await apolloClient.query({
        query: GET_NEW_JOB_FUNCTION,
        variables: { search: this.search },
      });
      this.info = res.data.getParents;
      this.inputs = this.info.map((i) => "");
    },
    setIndex(index, name, id) {
      if (id === this._id) {
        this.inputs[index] = "";
        this.isIndex = null;
        this._id = "";
        this.name = name
        this.error = "";
        this.status = false;
      } else {
        this.inputs[index] = name;
        this.isIndex = index;
        this._id = id;
        this.status = true;
        this.name = name
        this.error = "";
      }
      this.$forceUpdate();
    },
    async update(index) {
      await apolloClient
        .mutate({
          mutation: ADD_NEW_JOB_FUNCTION,
          variables: {
            pId: "",
            _id: this._id,
            name: this.inputs[index],
            status: true,
          },
        })
        .then((res) => {
          this.msg = res.data.addToParent;
          this.error = "";
          this.fetchJobFunction();
          setTimeout(() => {
            this.msg = "";
            this.status = false;
          }, 2000);
        })
        .catch((e) => {
          this.error = e.graphQLErrors[0].message;
        });
    },
    async add(index) {
      this.isIndex = index;
      if (!this.inputs[index]) {
        this.error = "ກະລຸນາປ້ອນຂໍ້ມູນກ່ອນ";
        return;
      }
      const obj = this.info[index];
      await apolloClient
        .mutate({
          mutation: ADD_NEW_JOB_FUNCTION,
          variables: {
            pId: obj._id,
            _id: this._id,
            name: this.inputs[index],
            status: false,
          },
        })
        .then((res) => {
          this.msg = res.data.addToParent;
          this.error = "";
          this.fetchJobFunction();
          setTimeout(() => {
            this.msg = "";
          }, 2000);
        })
        .catch((e) => {
          this.error = e.graphQLErrors[0].message;
        });
    },
    async sendMsgGPT() {
      const func = this.funcs.map((i) => { return "- " + i.name })
      const afterMap = func.join(' \n')
      const msg = `
${this.text}
 
*find positions from job description
*only answer in my reference here (with "Short answer, please."):

${afterMap}

      `
      console.log(msg)
      // Axios.defaults.headers = {
      //   "Content-Type": "application/json",
      //   "Authorization": `Bearer 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`,
      // }
      // const res = await Axios.post("https://api.openai.com/v1/chat/completions", {
      //   model: "gpt-3.5-turbo",
      //   messages: [{ "role": "user", "content": msg }]
      // })
      // console.log(res)
    }
  },
  created() {
    this.queryJobFunction()
    this.fetchJobFunction();
    setTimeout(() => {
      this.sendMsgGPT()
    }, 500)
  },
  watch: {
    "$store.getters.isAuthInfo": {
      handler() {
        if (
          this.$store.getters.isAuthInfo &&
          this.$store.getters.isAuthInfo !== null
        ) {
          this.permission = this.$store.getters.isAuthInfo;
        }
      },
      immediate: true,
      deep: true,
    },
  }
};
</script>

<style lang="scss" scoped>
.page {
  height: 100%;
  width: 100%;
  padding: 0;
  background-color: var(--bg-color) !important;
  display: flex;
  flex-direction: column;

  .page-header {
    border-bottom: 1px solid var(--border-color);
    padding: 10px 20px;
    margin-bottom: 0;
    height: 4rem;
    justify-content: space-between;
    background-color: #fff;

    .tabs {
      padding: 0;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 20px;
      overflow: hidden;
      border: none !important;

      li {
        cursor: pointer;
        font-size: var(--sm-font);
        display: flex;

        i {
          margin-right: 5px;
        }

        &.active {
          color: var(--primary-color);
          font-weight: 700;

          i {
            font-weight: 700;
          }
        }
      }
    }
  }

  .input-group {
    padding: 10px 0;
    display: flex;
    align-items: flex-end;
    gap: 10px;
    background-color: #fff;

    .field {
      flex-grow: 1;
      margin-bottom: 0;

      label {
        margin-bottom: 5px;
      }
    }
  }

  .page-content {
    padding: 20px;
    overflow: auto;
    display: flex;
    gap: 20px;

    ul {
      list-style: none !important;
      display: flex;
      flex-direction: column;
      gap: 5px;
      margin: 0;
      flex-grow: 1;

      p {
        font-size: var(--lg-font);
        margin: 0;
        font-weight: 700;
        color: var(--text-color);
        display: flex;
        align-items: center;
        gap: 10px;
      }

      li {
        background-color: #fff;
        border: 1px solid var(--border-color);
        padding: 10px;
        cursor: pointer;
        font-size: var(--sm-font);

        ul {
          margin-top: 10px;

          li {
            padding: 10px;
            display: flex;
            justify-content: space-between;

            i {
              color: var(--primary-color);
            }
          }
        }
      }
    }

    .widget {
      width: 100%;
      max-width: 400px;
      flex-grow: 1;
      padding: 20px;
      background-color: #fff;
      border: 1px solid var(--border-color);
      position: sticky;
      top: 0;
      display: flex;
      flex-direction: column;
      font-size: var(--md-font);

      .input-group {
        display: flex;
        gap: 10px;
        padding-bottom: 10px;
        margin-bottom: 10px;
        border-bottom: 1px solid var(--border-color);
      }

      .widget-header {
        padding-bottom: 10px;

        h3 {
          font-size: var(--md-font);
          color: var(--grey-text-color);
          margin-bottom: 5px;
        }

        p {
          font-weight: 700;
        }
      }

      .keywords {
        flex-grow: 1;
        overflow-y: auto;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-bottom: 20px;
        border-top: 1px solid var(--border-color);
        border-bottom: 1px solid var(--border-color);
      }

      .buttons {
        display: flex;

        .primary {
          flex-grow: 1;
        }
      }
    }
  }
}
</style>
